import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getTrabajoAgencias = (idarea) => apiActionCreator({
  'endpoint': `/wts/trabajoAgencias?idarea=${idarea}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TRABAJO_AGENCIAS,
    ActionTypes.FETCHED_TRABAJO_AGENCIAS,
    [
      ActionTypes.FETCHED_TRABAJO_AGENCIAS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createTrabajoAgencia = (payload) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/trabajoAgencias',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_TRABAJO_AGENCIA,
        [
          () => {
            dispatch(getTrabajoAgencias(payload.idarea));
            return {'type': ActionTypes.CREATED_TRABAJO_AGENCIA};
          },
          MessageActions.addMessageBoxInfo('Registro creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_TRABAJO_AGENCIA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': payload,
    }),
  );
};

export const updateTrabajoAgencia = (id, payload) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/trabajoAgencias?id=${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_TRABAJO_AGENCIA,
        [
          () => {
            dispatch(getTrabajoAgencias(payload.idarea));
            return {'type': ActionTypes.UPDATED_TRABAJO_AGENCIA};
          },
          MessageActions.addMessageBoxInfo('Registro actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_TRABAJO_AGENCIA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': payload,
    }),
  );
};
